export default "__VITE_ASSET__GwrYe4RJ__"